"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberValue = exports.getValue = exports.getAnyFieldsValue = exports.getRequiredIntermediateFieldsValue = exports.getPostProcessedFieldsValue = exports.getValuationFieldsValue = exports.getEligibilityFieldsValue = exports.getConcentrationLimitFieldsValue = void 0;
const common_1 = require("@finley-technologies/common");
const getConcentrationLimitFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty ===
        'eligibleExposureLessConcentrationLimitKickouts', `${concentrationLimitProperty} !==
      'eligibleExposureLessConcentrationLimitKickouts'`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getConcentrationLimitFieldsValue = getConcentrationLimitFieldsValue;
const getEligibilityFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty === 'eligibleExposure' ||
        concentrationLimitProperty === 'eligibilityKickout' ||
        concentrationLimitProperty === 'isEligible', `${concentrationLimitProperty} is not one of [eligibleExposure, eligibilityKickout, isEligible]`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getEligibilityFieldsValue = getEligibilityFieldsValue;
const getValuationFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty === 'valuation' ||
        concentrationLimitProperty === 'valuationRate', `${concentrationLimitProperty} !== 'valuation' ||
      ${concentrationLimitProperty} !== 'valuationRate'`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getValuationFieldsValue = getValuationFieldsValue;
const getPostProcessedFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty === 'normalizedExposure', `${concentrationLimitProperty} === 'normalizedExposure'`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getPostProcessedFieldsValue = getPostProcessedFieldsValue;
const getRequiredIntermediateFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty === 'exposure', `${concentrationLimitProperty} === 'exposure'`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getRequiredIntermediateFieldsValue = getRequiredIntermediateFieldsValue;
const getAnyFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    const value = propertyGroup[concentrationLimitProperty];
    return value;
};
exports.getAnyFieldsValue = getAnyFieldsValue;
const getValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    switch (concentrationLimitPropertyGroup) {
        case 'loanProductId':
            return fields.loanProductId;
        case 'concentrationLimitFields':
            return (0, exports.getConcentrationLimitFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'eligibilityFields':
            return (0, exports.getEligibilityFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'valuationFields':
            return (0, exports.getValuationFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'postProcessedFields':
            return (0, exports.getPostProcessedFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'requiredIntermediateFields':
            return (0, exports.getRequiredIntermediateFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'dynamicIntermediateFields':
        case 'baseFields':
            return (0, exports.getAnyFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'assignmentFields':
        case 'concentrationLimitWaivers':
            return (0, common_1.finleyAssert)(false, `Invalid field group: ${concentrationLimitPropertyGroup}`);
        default:
            return (0, common_1.finleyAssertUnreachable)(concentrationLimitPropertyGroup);
    }
};
exports.getValue = getValue;
const getNumberValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const value = (0, exports.getValue)({
        fields,
        concentrationLimitProperty,
        concentrationLimitPropertyGroup,
    });
    (0, common_1.finleyAssert)(typeof value === 'number', new common_1.error.FinleyError(`expected value for [${concentrationLimitPropertyGroup}.${concentrationLimitProperty}] to be a number, but found: [${value}]`, {
        metadata: {
            logMeta: {
                value,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            },
        },
    }));
    return value;
};
exports.getNumberValue = getNumberValue;
//# sourceMappingURL=getValue.js.map